module.exports = __webpack_public_path__ + "static/media/youth.8f94b3c5.png";